// ============================================================
// UI 환경설정 Vuex 모듈 (layout)
// 사이드바 접힘 등 UI 상태를 localStorage 와 동기화
// 키 네임스페이스: pineapple.*
// ============================================================

const LS_KEY_SIDEBAR = 'pineapple.sidebarCollapsed';

const readBool = (key) => {
  try {
    return localStorage.getItem(key) === 'true';
  } catch (e) {
    return false;
  }
};

const writeBool = (key, value) => {
  try {
    localStorage.setItem(key, String(value));
  } catch (e) {
    // ignore (private mode 등)
  }
};

const state = {
  sidebarCollapsed: readBool(LS_KEY_SIDEBAR),
};

const getters = {
  isSidebarCollapsed: (s) => s.sidebarCollapsed,
};

const mutations = {
  TOGGLE_SIDEBAR(s) {
    s.sidebarCollapsed = !s.sidebarCollapsed;
    writeBool(LS_KEY_SIDEBAR, s.sidebarCollapsed);
  },
  SET_SIDEBAR_COLLAPSED(s, value) {
    s.sidebarCollapsed = !!value;
    writeBool(LS_KEY_SIDEBAR, s.sidebarCollapsed);
  },
};

const actions = {
  toggleSidebar({ commit }) {
    commit('TOGGLE_SIDEBAR');
  },
  setSidebarCollapsed({ commit }, value) {
    commit('SET_SIDEBAR_COLLAPSED', value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
